module.exports = __webpack_public_path__ + "static/media/KapOrgLogo.9e4b2a67.svg";